import React from 'react';
import CurrencyText from '../../../../../../components/ui/labels/CurrencyText';
import Tooltip from '../../../../../../components/ui/tooltips/Tooltip';

const Info = ({ circleClassName, title, value, percentage, icon, tooltip, tooltipWidth }) => {
  return (
    <div
      className="bg-blueLight grid items-center p-4 gap-4"
      style={{ borderRadius: '20px', gridTemplateColumns: '80px 1fr' }}
    >
      {/* CIRCLE */}
      <span
        className={`text-xl font-semibold rounded-full w-20 h-20 flex items-center justify-center ${circleClassName}`}
      >
        {icon || (
          <>
            {percentage}
            <span className="text-sm">%</span>
          </>
        )}
      </span>

      {/* TEXT */}
      <div className="flex flex-col gap-1 min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-blueDarker text-base font-semibold truncate">{title}</span>

          {tooltip && <Tooltip content={tooltip} width={tooltipWidth} />}
        </div>

        <CurrencyText value={value || 0} size="normal" />
      </div>
    </div>
  );
};

export default Info;
